import userResources from "api/userResources";
import React, { useState } from "react";
import { toast } from "react-toastify";

export default function FollowUpModal({
  followUpData,
  onClose,
  followupable_type,
}) {
  const [followUpDate, setFollowUpDate] = useState("");
  const [followUpMessage, setFollowUpMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Convert "YYYY-MM-DDTHH:mm" to "YYYY-MM-DD HH:mm:00"
    const formattedDate = followUpDate
      ? followUpDate.replace("T", " ") + ":00"
      : "";

    const data = {
      receiver_id: followUpData?.assign_user_id,
      followed_up_at: formattedDate,
      follow_up_message: followUpMessage,
      followupable_type: followupable_type,
      followupable_id: followUpData?.enquiry_id,
    };

    try {
      toast.info("Submitting follow-up...", { autoClose: 2000 });
      const response = await userResources.setFollowUp(
        followUpData?.assign_user_id,
        data
      );
      if (response.status === 201) {
        toast.success(response?.data?.message, { autoClose: 3000 });
        onClose(); // Optionally close the modal on success
      }
    } catch (error) {
      console.error("Error submitting follow-up:", error);
      toast.error("Failed to submit follow-up. Please try again.", {
        autoClose: 3000,
      });
    }
  };

  const handleReset = () => {
    setFollowUpDate("");
    setFollowUpMessage("");
  };

  return (
    <div>
      <div
        className="hide-scroll-bar fixed inset-0 h-screen transform bg-gray-900 p-4 text-white shadow-lg sm:left-1/2  sm:top-1/2 sm:h-72 sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-3xl"
        style={{ zIndex: 50 }}
      >
        <div>
          <button
            className="absolute right-4 top-4 z-10 text-red-600 hover:text-red-800"
            onClick={onClose}
          >
            ✕
          </button>
          <div>
            <h2 className="mb-2 text-2xl text-[#ff4e41]">Set Follow-up</h2>
            <form onSubmit={handleSubmit} className="flex flex-col gap-2">
              <div>
                <label htmlFor="followed_up_at">Followed-up date:</label>
                <input
                  type="datetime-local"
                  id="followed_up_at"
                  name="followed_up_at"
                  value={followUpDate}
                  onChange={(e) => setFollowUpDate(e.target.value)}
                  className="mt-1 block w-full cursor-pointer rounded-md border bg-white p-2 text-black shadow-sm outline-none sm:text-sm"
                  placeholder="Select a date and time"
                  min={new Date().toISOString().slice(0, 16)}
                />
              </div>
              <div>
                <label htmlFor="follow_up_message">Follow-up message:</label>
                <textarea
                  id="follow_up_message"
                  name="follow_up_message"
                  value={followUpMessage}
                  onChange={(e) => setFollowUpMessage(e.target.value)}
                  className="block w-full rounded-sm border border-gray-500 bg-white p-2 text-black"
                  placeholder="Follow Up Message"
                  rows={2}
                />
              </div>
              <div className="mt-2 flex items-center justify-between">
                <button
                  type="button"
                  onClick={handleReset}
                  className="cursor-pointer rounded-md border border-red-500 px-4 py-2 text-sm text-red-600  hover:bg-red-600 hover:text-white"
                >
                  Reset
                </button>
                <button
                  type="submit"
                  className="cursor-pointer rounded-md border border-green-500 px-4 py-2 text-sm text-green-600 hover:bg-green-600 hover:text-white"
                  disabled={!followUpDate && !followUpMessage}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
